import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { StepNavigation } from "../../utilities/StepperComponents";

const EmploymentDetails = ({ error, disableButton, data, handleChange, nextStep, prevStep }) => {
	const [isOtherOrg, setIsOtherOrg] = useState(data?.organisationName && data.organisationName !== "University of Nigeria");

	const handleOrgChange = (e) => {
		const value = e.target.value;
		setIsOtherOrg(value === "Others");
		handleChange(e);
	};

	return (
		<div className="modern-form-container">
			<Form>
				<div className="modern-form-group">
					<label className="modern-label">Name of Organization</label>
					<select
						className={`modern-form-control ${error?.organisationName ? 'is-invalid' : ''}`}
						name="organisationName"
						defaultValue={data?.organisationName}
						onChange={handleOrgChange}
					>
						<option value="">Select organization</option>
						<option value="University of Nigeria">University of Nigeria</option>
						<option value="Others">Others</option>
					</select>
					{error?.organisationName && <div className="invalid-feedback d-block">{error.organisationName}</div>}
				</div>

				{isOtherOrg && (
					<div className="modern-form-group">
						<label className="modern-label">Specify Organization</label>
						<input
							className="modern-form-control"
							type="text"
							name="organisationName"
							placeholder="Enter name of organization"
							defaultValue={data?.organisationName === "Others" ? "" : data?.organisationName}
							onChange={handleChange}
						/>
					</div>
				)}

				<Row>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Campus</label>
							<select
								className="modern-form-control"
								name="campusName"
								defaultValue={data?.campusName}
								onChange={handleChange}
							>
								<option value="">Select campus</option>
								<option value="NSUKKA">Nsukka Campus</option>
								<option value="ENUGU">Enugu Campus</option>
								<option value="COLLEGE OF MEDICINE">College of Medicine</option>
								<option value="N/A">Not Applicable</option>
							</select>
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Category</label>
							<select
								className={`modern-form-control ${error?.category ? 'is-invalid' : ''}`}
								name="category"
								defaultValue={data?.category}
								onChange={handleChange}
							>
								<option value="">Select category</option>
								<option value="Senior">Senior Category</option>
								<option value="Junior">Junior Category</option>
							</select>
							{error?.category && <div className="invalid-feedback d-block">{error.category}</div>}
						</div>
					</Col>
				</Row>

				<Row>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Faculty</label>
							<input
								className="modern-form-control"
								type="text"
								name="faculty"
								placeholder="e.g. Science"
								defaultValue={data?.faculty}
								onChange={handleChange}
							/>
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Department</label>
							<input
								className="modern-form-control"
								type="text"
								name="department"
								placeholder="e.g. Physics"
								defaultValue={data?.department}
								onChange={handleChange}
							/>
						</div>
					</Col>
				</Row>

				<Row>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Rank / Designation</label>
							<input
								className={`modern-form-control ${error?.rank ? 'is-invalid' : ''}`}
								type="text"
								name="rank"
								defaultValue={data?.rank}
								onChange={handleChange}
							/>
							{error?.rank && <div className="invalid-feedback d-block">{error.rank}</div>}
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Staff Number</label>
							<input
								className={`modern-form-control ${error?.staffNum ? 'is-invalid' : ''}`}
								type="text"
								name="staffNum"
								defaultValue={data?.staffNum}
								onChange={handleChange}
							/>
							{error?.staffNum && <div className="invalid-feedback d-block">{error.staffNum}</div>}
						</div>
					</Col>
				</Row>

				<Row>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Grade Level</label>
							<input
								className={`modern-form-control ${error?.gradeLevel ? 'is-invalid' : ''}`}
								type="text"
								name="gradeLevel"
								defaultValue={data?.gradeLevel}
								onChange={handleChange}
							/>
							{error?.gradeLevel && <div className="invalid-feedback d-block">{error.gradeLevel}</div>}
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Step</label>
							<input
								className={`modern-form-control ${error?.step ? 'is-invalid' : ''}`}
								type="text"
								name="step"
								defaultValue={data?.step}
								onChange={handleChange}
							/>
							{error?.step && <div className="invalid-feedback d-block">{error.step}</div>}
						</div>
					</Col>
				</Row>

				<Row>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Salary Structure</label>
							<input
								className={`modern-form-control ${error?.salaryStructure ? 'is-invalid' : ''}`}
								type="text"
								name="salaryStructure"
								placeholder="e.g. CONTISS"
								defaultValue={data?.salaryStructure}
								onChange={handleChange}
							/>
							{error?.salaryStructure && <div className="invalid-feedback d-block">{error.salaryStructure}</div>}
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">IPPIS Number</label>
							<input
								className={`modern-form-control ${error?.ippisNum ? 'is-invalid' : ''}`}
								type="text"
								name="ippisNum"
								defaultValue={data?.ippisNum}
								onChange={handleChange}
							/>
							{error?.ippisNum && <div className="invalid-feedback d-block">{error.ippisNum}</div>}
						</div>
					</Col>
				</Row>

				<Row>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Assumption of Duty Date</label>
							<input
								className={`modern-form-control ${error?.assumptionDate ? 'is-invalid' : ''}`}
								type="date"
								name="assumptionDate"
								defaultValue={data?.assumptionDate}
								onChange={handleChange}
							/>
							{error?.assumptionDate && <div className="invalid-feedback d-block">{error.assumptionDate}</div>}
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Date of Retirement</label>
							<input
								className={`modern-form-control ${error?.retirementDate ? 'is-invalid' : ''}`}
								type="date"
								name="retirementDate"
								defaultValue={data?.retirementDate}
								onChange={handleChange}
							/>
							{error?.retirementDate && <div className="invalid-feedback d-block">{error.retirementDate}</div>}
						</div>
					</Col>
				</Row>

				<StepNavigation
					currentStep={2}
					totalSteps={4}
					onPrev={prevStep}
					onNext={nextStep}
					disableNext={disableButton}
				/>
			</Form>
		</div>
	);
};

export default EmploymentDetails;
